import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const selectedLayer = (state: RootState) => state.pages.editor.selectedLayer;

const getSelectedLayer = createSelector([selectedLayer], (layer) => layer);

export default getSelectedLayer;
